import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, setToken } from "@/lib/api";

const AuthCtx = createContext(null);

export const detectDevice = () => {
  const ua = navigator.userAgent;
  const browser = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Safari\//.test(ua) ? "Safari" : /Firefox\//.test(ua) ? "Firefox" : "متصفح";
  const os = /iPhone|iPad/.test(ua) ? "iOS" : /Android/.test(ua) ? "Android" : /Mac/.test(ua) ? "macOS" : /Windows/.test(ua) ? "Windows" : /Linux/.test(ua) ? "Linux" : "";
  return `${browser} · ${os}`.trim();
};

export function AuthProvider({ children }) {
  const [session, setSession] = useState(undefined);

  useEffect(() => {
    const onLogout = () => setSession(null);
    window.addEventListener("aql4-logout", onLogout);
    if (!getToken()) { setSession(null); return () => window.removeEventListener("aql4-logout", onLogout); }
    api.get("/auth/me").then((r) => setSession(r.data.session)).catch(() => setSession(null));
    return () => window.removeEventListener("aql4-logout", onLogout);
  }, []);

  const login = useCallback(async (pin) => {
    const { data } = await api.post("/auth/login", { pin, device: detectDevice() });
    setToken(data.token);
    setSession(data.session);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setToken(null);
    setSession(null);
  }, []);

  return <AuthCtx.Provider value={{ session, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
